module.exports = __webpack_public_path__ + "img/81.bbe879d8.jpg";